import classNames from "classnames";
import React from "react";
import styles from "./styles.module.scss";

interface Props {
  children?: React.ReactNode;
  className?: string;
  type: "light" | "primary" | "secondary";
  transform?: "capitalize" | "uppercase" | "none";
}

const Label: React.FC<Props> = ({
  children,
  className,
  transform = "none",
  type,
}) => {
  return (
    <div
      className={classNames(
        styles.container,
        {
          [styles.primary]: type === "primary",
          [styles.secondary]: type === "secondary",
        },
        className
      )}
      style={{ textTransform: transform }}
    >
      {children}
    </div>
  );
};

export default Label;
